import gql from 'graphql-tag';

const DELETE_PRICESHEET = gql`
  mutation ($pricesheetId: String!) {
    pricesheet: deletePricesheet(pricesheetId: $pricesheetId) {
      label,
      baseMarkup,
      scope,
      scopeId
    }
  }
`;

export default DELETE_PRICESHEET;
